import React, {memo} from "react";
import {useTranslation} from "react-i18next";
import {useField, useFormikContext} from "formik";
import cn from "classnames";
import {getFullName} from "helpers/helper";
import {SignContractMemberAutocomplete} from "./SignContractMemberAutocomplete";

const CounterpartyContactAutocompleteField = memo(
  ({name, label, placeholder, addClass, members}) => {
    const {t} = useTranslation();
    const [field, meta, helpers] = useField(name);
    const {setFieldValue} = useFormikContext();

    return (
      <div
        className={cn(
          "form-field_wrapper",
          "__tiny",
          "__bold",
          "__flat-view",
          addClass ?? "mb-1"
        )}
      >
        {label && (
          <label className="__uppercase __bold">
            {t(label)}
          </label>
        )}
        <SignContractMemberAutocomplete
          localMembers={members}
          value={field.value}
          onChange={(val) => helpers.setValue(val)}
          onSelect={(member) => {
            if (member?.User) {
              setFieldValue(
                "counterpartyContactFullName",
                getFullName(member.User.firstName, member.User.lastName)
              );
              setFieldValue("counterpartyContactEmail", member.User.email ?? "");
              setFieldValue("counterpartyContactMobilePhone", member.User.mobilePhone ?? "");
            }
          }}
          onBlur={() => helpers.setTouched(true)}
          placeholder={placeholder}
        />
        {meta.touched && meta.error && (
          <p className="form-error">{t(meta.error)}</p>
        )}
      </div>
    );
  }
);

export {CounterpartyContactAutocompleteField};